import React from 'react';
import { Icon, Modal } from '@ss/mtd-react';
import './index.scss';

interface Props {
  name?: string;
  url: any;
  onRemove: () => void;
  mode?: 'edit' | 'view';
}

interface State {
  visible: boolean;
  mask: boolean;
}
class FileList extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      mask: false, // 图片展示地址
    };
  }

  handleShowBigImg = () => {
    this.setState({ visible: true });
  };

  handleClose = () => {
    this.setState({ visible: false });
  };

  handleMoseEnter = () => {
    this.setState({ mask: true });
  };

  handleMoseLeave = () => {
    this.setState({ mask: false });
  };

  //  onClick={() => onDownload && onDownload()}
  render() {
    const {
      name,
      url,
      onRemove,
      // 默认edit，兼容其他已存场景
      mode = 'edit',
    } = this.props;
    const { mask, visible } = this.state;
    return (
      <>
        <ul className="filelist">
          <li className="filelist__item" onMouseEnter={this.handleMoseEnter} onMouseLeave={this.handleMoseLeave}>
            <img src={url} alt="" className="filelist__img" />
            {mask && (
              <div className="filelist__buttons">
                {true && <Icon className="filelist__show" type="visibility-on-o" onClick={this.handleShowBigImg} />}
                {true && url && (
                  // eslint-disable-next-line react/jsx-no-target-blank
                  <a target="_blank" download className="filelist__download" href={url}>
                    <Icon type="download-o" />
                  </a>
                )}
                {/* 非预览态 */}
                {mode !== 'view' && (
                  <Icon className="filelist__delete" type="delete-o" onClick={() => onRemove && onRemove()} />
                )}
              </div>
            )}
          </li>
        </ul>
        {visible && (
          <Modal onClose={this.handleClose} style={{ width: '400px' }} title="">
            <Modal.Body>
              <img src={url} width="100%" alt={name} />
            </Modal.Body>
          </Modal>
        )}
      </>
    );
  }
}

export default FileList;
